import * as React from "react";

import { Experiment as BernieExperiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";

import { Experiment } from "components/utility/experiment";
import { CustomerNotificationsWithDialogWrapper } from "components/shared/CustomerNotifications/CustomerNotificationsWithDialogWrapper";
import {
  CovidBannerVersions,
  ReasonsToBelieveWrapper,
} from "components/shared/ReasonsToBelieve/ReasonsToBelieveWrapper";

/**
 * Manage the different versions for customer notifications
 */
export const CustomerNotificationsInPage: React.FC = () => {
  return (
    <BernieExperiment name={Experiment.Surface_PWA_SF_Travel_Advisory_Chatbot}>
      <ExperimentControl />
      <ExperimentVariant bucket={1}>
        <CustomerNotificationsWithDialogWrapper
          location="IN_PAGE"
          className="customerNotificationSquare customerNotificationWithDialog all-x-padding-six"
        />
      </ExperimentVariant>
      <ExperimentVariant bucket={2}>
        <ReasonsToBelieveWrapper location="IN_PAGE" className="reasons-to-believe" />
      </ExperimentVariant>
      <ExperimentVariant bucket={3}>
        <ReasonsToBelieveWrapper location="IN_PAGE" version={CovidBannerVersions.TWO} hasSubtitle={true} />
      </ExperimentVariant>
    </BernieExperiment>
  );
};
